import { NgxMatDatetimePicker } from '@angular-material-components/datetime-picker';
import { AfterViewInit, Directive, Host } from '@angular/core';

/**
 * When applied to ngx-mat-datetime-picker, makes the popup close and apply the selection
 * as soon as the user clicks a date (no need to click the Done button).
 */
@Directive({
    selector: 'ngx-mat-datetime-picker[closeOnDateSelect]',
})
export class CloseOnDateSelectDirective implements AfterViewInit {
    constructor(@Host() private picker: NgxMatDatetimePicker<unknown>) {}

    ngAfterViewInit(): void {
        const originalSelect = this.picker.select.bind(this.picker);
        (this.picker as { select: (date: unknown) => void }).select = (date: unknown) => {
            originalSelect(date);
            this.picker.ok();
        };
    }
}
